module.exports = __webpack_public_path__ + "static/media/card-Charlie-mobile.32f5a9ee.svg";